module.exports = __webpack_public_path__ + "img/52002767_L.900726f3.png";